<script setup lang="ts">
// TODO: This file is a clone of ckbase error.vue
import type { NuxtError } from "#app";
definePageMeta({
  allowAnonymous: true,
});
const props = defineProps<{ error: NuxtError }>();

const { t } = useI18n();
const localePath = useLocalePath();

const friendlyData = computed(() =>
  props.error?.data && props.error.cause instanceof $ck.utils.PageFriendlyError ? props.error.cause.data : undefined,
);

useHead({
  title: props.error.statusText ? t(props.error.statusText) : "404 - " + t("errors.pages.404.title"),
});

function handleAction() {
  if (friendlyData.value?.redirect) {
    clearError({
      redirect: $ck.utils.unwrapGetter(friendlyData.value.redirect),
    });
    return;
  }

  clearError({ redirect: localePath("/") });
}
/**
 * Fix for related issue: https://github.com/nuxt/nuxt/issues/34579
 */
setTimeout(() => {
  const activeHead = useHead({
    title: props.error.statusText
      ? t(props.error.statusText)
      : `${props.error?.status}  -  ${t("errors.pages.404.title")}`,
  });
  const head = useLocaleHead({ dir: true, seo: true, lang: true });
  activeHead.patch({
    htmlAttrs: {
      lang: head.value.htmlAttrs?.lang ?? "en",
      dir: <"ltr" | "rtl">head.value.htmlAttrs?.dir ?? "ltr",
      style: `--direction: ${head.value.htmlAttrs?.dir ?? "ltr"};`,
    },
    title: `${props.error?.statusCode}  -  ${t("errors.pages.404.title")}`,
  });
}, 0);
</script>

<template>
  <NuxtLayout name="error">
    <section
      class="flex flex-col items-center justify-center border-2 border-ngray-6 rounded-lg p-4 min-w-[420px] min-h-[491px] gap-4 bg-ngray-8"
    >
      <h1 class="text-nred-3 text-[115px] font-extrabold leading-none">
        {{ friendlyData?.heading ? t(friendlyData?.heading) : "404" }}
      </h1>

      <h2 class="text-nblue-1 text-lg font-bold tracking-[5px] leading-[25px] px-5">
        {{ t(friendlyData?.subHeading || "errors.pages.404.title") }}
      </h2>

      <p class="text-sm font-normal text-nblue-1 w-[230px] text-center">
        {{ t(friendlyData?.message || "errors.pages.404.message") }}
      </p>
      <button
        class="text-ngray-8 bg-nblue-1 cursor-pointer rounded-full px-6 py-3 font-semibold text-center"
        @click="handleAction"
      >
        {{ t($ck.utils.unwrapGetter(friendlyData?.actionText) || "buttons.returnHome") }}
      </button>

      <display-version theme="blue" />
      <slot />
    </section>
  </NuxtLayout>
</template>
